import Axios from 'axios';
import {ApiResultModel} from '../models/common.model';
import {
    IGetCustomerContractResponse,
    IGetCustomerContractTermsRequest,
    IRequestSignOtpResponse,
    ISignContractRequest,
} from '../models/customerContract.model';
import {APIBASE_URL, CUSTOMER_CONTRACT_URL} from '../config/cacheKey';

export const GetCustomerContract = async (data: {
    referenceKey: string;
}): Promise<IGetCustomerContractResponse> => {
    return await Axios.post<ApiResultModel<IGetCustomerContractResponse>>(
        // SERVIES_URL
        APIBASE_URL + CUSTOMER_CONTRACT_URL + '/Generate',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const RequestSignOtp = async (data: {
    referenceKey: string;
}): Promise<IRequestSignOtpResponse> => {
    return await Axios.post<ApiResultModel<IRequestSignOtpResponse>>(
        // SERVIES_URL
        APIBASE_URL + CUSTOMER_CONTRACT_URL + '/RequestSignOtp',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetCustomerContractTerms = async (
    data: IGetCustomerContractTermsRequest
): Promise<string[]> => {
    return await Axios.post<ApiResultModel<string[]>>(
        // SERVIES_URL
        APIBASE_URL + CUSTOMER_CONTRACT_URL + '/GetTerms',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const SignContractOtp = async (
    data: ISignContractRequest
): Promise<boolean> => {
    return await Axios.post<ApiResultModel<boolean>>(
        // SERVIES_URL
        APIBASE_URL + CUSTOMER_CONTRACT_URL + '/Sign',
        data
    ).then((result) => {
        return result.data.data;
    });
};
